var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"copyright-footer"},[_c('span',{staticClass:"copyright-footer-mini__copy"},[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+".")]),_vm._v(" "),_c('span',{staticClass:"copyright-footer-mini__text"},[_vm._v("All Rights Reserved")])])
}
var staticRenderFns = []

export { render, staticRenderFns }